<template>
  <div
    class="d-flex justify-content-between py-2 px-2 rounded align-items-start transaction-row"
    :class="{'transaction-row--plus': transaction.creditDebitIndicator === 'CRDT'}"
  >
    <div class="d-md-flex transaction-row__left-col">
      <div class="pr-3 text-md-left d-md-flex">
        <p class="mb-0 transaction-row__date">{{ dateLocalized }}</p>
      </div>
      <div class="d-md-flex pr-3">
        <p class="mb-0 transaction-row__title transaction-row__mobile-small">
          {{[remittance, creditor, debtor].filter(v => !!v).join(' / ')}}
        </p>
      </div>
    </div>
    <div class="d-md-flex justify-content-end transaction-row__right-col text-right">
      <span class="text-nowrap transaction-row__price order-2">
        <span v-if="transaction.transactionAmount" :class="{'striked-text text-secondary': isCancelled}">
          <span :class="{'text-success': transaction.creditDebitIndicator === 'CRDT'}">{{transactionAmount}}</span>
        </span>
      </span>
      <p class="mb-0 order-1 transaction-row__mobile-small">
        {{ transactionStatus }}
      </p>
    </div>
  </div>
</template>

<script>
import { currencySymbols, transactionStatuses } from '../../../constants'
import { dateOptions } from '../../../language/i18n'

export default {
  props: {
    transaction: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    creditor() {
      const creditorInfo = []
      if (this.transaction.creditor) {
        if (this.transaction.creditor.name) {
          creditorInfo.push(this.transaction.creditor.name)
        }
      }
      return creditorInfo.join(' ')
    },
    dateLocalized() {
      const date = this.transaction && (this.transaction.transactionDate || this.transaction.bookingDate)
      if (date) {
        return new Date(date).toLocaleDateString(this.$i18n.locale, dateOptions(this.$i18n.locale))
      }
      return ''
    },
    debtor() {
      const debtorInfo = []
      if (this.transaction.debtor) {
        if (this.transaction.debtor.name) {
          debtorInfo.push(this.transaction.debtor.name)
        }
      }
      return debtorInfo.join(' ')
    },
    isCancelled() {
      return this.transaction.status === transactionStatuses.Canceled ||
             this.transaction.status === transactionStatuses.Rejected
    },
    remittance() {
      if (this.transaction.remittanceInformation) {
        return this.transaction.remittanceInformation.join(' ')
      }
      return ''
    },
    transactionAmount() {
      const amountInfo = []
      if (this.transaction.creditDebitIndicator === 'DBIT') {
        amountInfo.push('-')
      }
      amountInfo.push(this.transaction.transactionAmount.amount)
      amountInfo.push(
        currencySymbols[this.transaction.transactionAmount.currency.toLowerCase()] ||
        this.transaction.transactionAmount.currency
      )
      return amountInfo.join(' ')
    },
    transactionStatus() {
      return this.$t(`accountPage.transactionStatus.${this.transaction.status}`)
    }
  },
  methods: {
    getFormattedDate(date) {
      const dateValue = new Date(date)

      return {
        day: `${dateValue.getDate()}`.padStart(2, '0'),
        month: dateValue.getMonth()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../style/variables";
@import "~bootstrap/scss/mixins";

.transaction-row{
  background-color: $gray-100;
  background-color: var(--element-bg-dark);
  margin-bottom: 0.2rem;
  &:hover{
    background-color: $gray-200;
    background-color: var(--element-bg-darker);
  }
  &--plus{
    background-color: $theme-light;
    background-color: var(--element-theme-light);
  }
  @include media-breakpoint-up(md) {
    &__date{
      width: 90px;
    }
    &__title{
      min-width: 200px;
      padding-right: 1rem;
    }
    &__price{
      min-width: 120px;
    }
    &__left-col{
      width: 70%;
    }
    &__right-col{
      width: 30%;
    }
  }
  @include media-breakpoint-down(sm) {
    &__mobile-small{
      font-size: $small-font-size;
    }
  }
  .striked-text{
    text-decoration: line-through;
  }
}
</style>
